import { render } from "./wpModal.vue?vue&type=template&id=ff4a56da"
import script from "./wpModal.vue?vue&type=script&lang=js"
export * from "./wpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.90.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__